import React from 'react';

const FCButton = (props) => {
  const { width, ready, type, children } = props;

  return (
    <button
      style={{ width: width, cursor: ready ? 'pointer' : 'not-allowed' }}
      className='FCButton'
      type={type ? type : 'submit'}
    >
      {children}
    </button>
  );
};

export default FCButton;
